import {
  UPDATE_LOCATION_DETAILS,
  RESTAURANT_LOCATION_SEARCH_REQUEST,
  RESTAURANT_LOCATION_SEARCH_SUCCESS,
  RESTAURANT_LOCATION_SEARCH_FAILURE,
  BRAND_LOCATION_SEARCH_REQUEST,
  BRAND_LOCATION_SEARCH_SUCCESS,
  BRAND_LOCATION_SEARCH_FAILURE,
  LOCATION_SEARCH_MODAL_SHOW,
  LOCATION_SEARCH_MODAL_HIDE,
  SHOW_VOTE_AREA_MODAL,
  HIDE_VOTE_AREA_MODAL,
  SHOW_UNDELIVERABLE_MODAL,
  HIDE_UNDELIVERABLE_MODAL,
  FOCUS_LOCATION_SEARCH,
  BLUR_LOCATION_SEARCH,
} from '../../actions/types';

const initialState = {
  loading: false,
  focused: false,
  error: null,
  showModal: false,
  showVoteAreaModal: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_LOCATION_DETAILS: {
      const { post_code, formatted_address, lat, lng } = action.payload; // eslint-disable-line camelcase
      return {
        ...state,
        post_code,
        formatted_address,
        lat,
        lng,
      };
    }
    case RESTAURANT_LOCATION_SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case RESTAURANT_LOCATION_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        restaurantsRedirectLocation: action.payload.url,
        error: null,
      };
    case RESTAURANT_LOCATION_SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          status: action.status,
          message: action.message,
          type: action.payload.type,
        },
      };
    case BRAND_LOCATION_SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case BRAND_LOCATION_SEARCH_SUCCESS: {
      const { restaurant_url: menuRedirectLocation } = action.payload.found_restaurant;
      return {
        ...state,
        menuRedirectLocation,
        loading: false,
        error: null,
      };
    }
    case BRAND_LOCATION_SEARCH_FAILURE: {
      const { brand, post_code: postcode, geohash } = action.payload.query || {};

      return {
        ...state,
        loading: false,
        query: {
          brand,
          postcode,
          geohash,
        },
        error: {
          type: 'UNDELIVERABLE',
        },
      };
    }
    case LOCATION_SEARCH_MODAL_SHOW:
      return {
        ...state,
        showModal: true,
      };
    case LOCATION_SEARCH_MODAL_HIDE:
      return {
        ...state,
        showModal: false,
      };
    case SHOW_VOTE_AREA_MODAL:
      return {
        ...state,
        showVoteAreaModal: true,
      };
    case HIDE_VOTE_AREA_MODAL:
      return {
        ...state,
        showVoteAreaModal: false,
      };
    case SHOW_UNDELIVERABLE_MODAL:
      return {
        ...state,
        showUndeliverableModal: true,
      };
    case HIDE_UNDELIVERABLE_MODAL:
      return {
        ...state,
        showUndeliverableModal: false,
      };
    case FOCUS_LOCATION_SEARCH:
      return {
        ...state,
        focused: true,
      };
    case BLUR_LOCATION_SEARCH:
      return {
        ...state,
        focused: false,
      };
    default:
      return state;
  }
}
